import React from "react"
import cx from "classnames"
import styled from "@emotion/styled"
import BlockContent from "@sanity/block-content-to-react"
import { Serializer } from "src/utils/serializer"
import { typography } from "src/styles"

const Wrapper = styled.div`
  > * {
    &.first-item {
      margin-top: 0;
    }
    &.last-item {
      margin-bottom: 0;
      &:empty {
        display: none;
      }
    }
  }
`

const StyledBlockContent = styled(BlockContent)`
  white-space: pre-wrap;
  * {
    white-space: pre-wrap;
  }
  .embeded-content {
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
    max-width: 100%;
    width: 100%;
    width: 100%;
    .video-wrapper,
    .youtube-video-wrapper,
    .gatsby-image-wrapper {
      border-radius: var(--card-border-radius);
      overflow: hidden;
    }
  }
  .cta-bar section {
    padding: 0;
    grid-column: 1/-1;
  }
  .cta-bar section div div {
    grid-column: 1/-1;
  }
  .cta-bar section div div h4 {
    margin-top: 0;
  }
  h1,
  h2 {
    margin-top: 1em;
  }
  h3,
  h4,
  h5 {
    margin-top: 1.5em;
  }
  p {
    min-height: 1em;
    &.last-item {
      margin-bottom: 0;
      &:empty {
        display: none;
      }
    }
  }
  > * {
    &.first-item {
      margin-top: 0;
    }
    &.last-item {
      margin-bottom: 0;
      &:empty {
        display: none;
      }
    }
  }
  dl {
    margin: 0.5em 0;
    dt {
      ${typography.h6}
    }
    dd {
      color: var(--light-text-color);
      margin-bottom: 1em;
    }
    &:not(:last-of-type) {
      dd {
        margin-bottom: 1em;
      }
    }
  }
  ol,
  ul {
    padding: 0;
    list-style: none;
    margin-top: 1em;
    margin-bottom: 1em;
    counter-reset: item;
    text-align: left;
    li {
      counter-increment: item;
      &:before {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  ul li {
    position: relative;
    padding-left: 1em;
    margin: 0.75em 0;
    &:before {
      position: absolute;
      top: 0.75em;
      margin-top: -3px;
      border-radius: 50%;
      content: "";
      display: block;
      width: 6px;
      height: 6px;
      background: currentcolor;
    }
  }
  ol li {
    position: relative;
    padding-left: 1em;
    margin: 0.75em 0;
    &:before {
      position: absolute;
      text-align: right;
      top: 0;
      left: 0;
      width: 0.5em;
      font-size: 0.75em;
      font-weight: ${typography.bold};
      content: counter(item);
      display: block;
    }
  }
`

const SanityRichText = ({ text, className, newStyle }) => {
  if (text) {
    text[0].firstItem = true
    text[text?.length - 1].lastItem = true
  }
  return (
    <Wrapper className={className}>
      <StyledBlockContent
        className={cx(newStyle ? "text-new" : "")}
        blocks={text?._rawText || text?.text || text}
        serializers={Serializer}
      />
    </Wrapper>
  )
}

export default SanityRichText
